import { WorkUnitGet }                          from "../../../../../services/pages/workunit/getWorkUnit";
import { createContext, useEffect, useState }   from "react";
import { getMonthYear }                         from "../../../../../helpers/default_helper";
import { FormTriKrama }                         from "../forms/tri_krama";
import { getEmployeeByName }                    from "../../../../../services/pages/employee/get";
import moment                                   from "moment";

const current           = new Date();

const monthNow          = `${moment(current).format("MM")}`
const yearNow           = `${moment(current).format("YYYY")}`
const KualitatifContext = createContext(null)

let userDataTxt         = localStorage.getItem("userData")
let userData            = JSON.parse(userDataTxt)
let role                = ""
let workunitName        = ""

if(userData !== null){
    workunitName = userData.workunit
    if(userData.user_group !== null){
        role = userData.user_group[0].name
    }else{
        role = ""
    }
}

const KualitatifContextProvider = (props) => {

    const [add_button, set_add]                             = useState(false)
    const [id, set_id]                                      = useState(false)
    const [form, set_form]                                  = useState(null)
    const [visibilityModalDetail, setVisibilityModalDetail] = useState(false)
    const [visibilityModalEdit, setVisibilityModalEdit]     = useState(false)
    const [activeDetailReport, setActiveDetailReport]       = useState(null)
    const [activeReportTypeID, setActiveReportTypeID]       = useState(null)
    const [activeReportTitle, setActiveReportTitle]         = useState(null)
    const [refresh, set_refresh]                            = useState()
    const [periode_context, set_periode_context]            = useState(yearNow+"-"+monthNow)
    const [activeWorkunit, setActiveWorkunit]               = useState(0)
    const [activeWorkunitName, setActiveWorkunitName]       = useState("")
    const [searchParam, setSearchParam]                     = useState({ search: "" })
    const [keyword, setKeyword]                             = useState("")
    const [showDetailKuantitatif, setShowDetailKuantitatif] = useState(false)
    const [selectedKuantitatif, setSelectedKuantitatif]     = useState(0)
    const [idDetailKuantitatif, setIdDetailKuantitatif]     = useState([])
    const [employeeList, setEmployeeList]                   = useState([])

    const [PeriodeParam, setPeriodeParam]                   = useState({
        month_start: monthNow,
        year_start: yearNow,
        month_end: monthNow,
        year_end: yearNow
    })

    const handleMonthFilter = (data) => {
        window.localStorage.setItem("date-filter", data.target.value)
        set_periode_context(data.target.value)
    }

    function handleSearchSet(text) {
        setSearchParam({ search: text })
    }

    const handleRangeMonthFilter = (data) => {
        let StartPeriod = getMonthYear(data.periode[0])
        let LastPeriod = getMonthYear(data.periode[1])
        let params = {
            month_start: StartPeriod[1],
            year_start: StartPeriod[0],
            month_end: LastPeriod[1],
            year_end: LastPeriod[0],
        }
        setPeriodeParam(params)

        let monthData = `${StartPeriod[0]}-${StartPeriod[1]}`;
        let monthDataLast = `${LastPeriod[0]}-${LastPeriod[1]}`;
        let monthValid = `${moment().format("YYYY-MM")}`
        let monthValidLast = `${moment().format("YYYY-MM")}`

        if ((monthData === monthValid && monthDataLast === monthValidLast)) {
            set_add(true)
        } else {
            set_add(false)
        }
    }

    const handleForm = () => {
        switch (parseInt(id)) {
            case 1:
                set_form(FormTriKrama)
            default:
                break;
        }
    }

    const getEmployeeContext = () => {
        getEmployeeByName("").then(resp => {
            if (resp.data !== null) {
                setEmployeeList(resp?.data)
            }
        })
    }

    useEffect(() => {
        getEmployeeContext()
    }, [])

    return (
        <>
            <KualitatifContext.Provider value={{
                handleSearchSet,
                searchParam,
                PeriodeParam,
                handleForm,
                handleMonthFilter,
                handleRangeMonthFilter,
                id,set_id,
                add_button, set_add,
                periode_context, set_periode_context,
                visibilityModalDetail, setVisibilityModalDetail,
                visibilityModalEdit, setVisibilityModalEdit,
                activeDetailReport, setActiveDetailReport,
                activeReportTypeID, setActiveReportTypeID,
                activeReportTitle, setActiveReportTitle,
                activeWorkunit, setActiveWorkunit,
                activeWorkunitName, setActiveWorkunitName,
                showDetailKuantitatif, setShowDetailKuantitatif,
                selectedKuantitatif, setSelectedKuantitatif,
                idDetailKuantitatif, setIdDetailKuantitatif,
                refresh, set_refresh,
                keyword, setKeyword,
                role,
                workunitName,
                employeeList, getEmployeeContext
            }}>
                {props.children}
            </KualitatifContext.Provider>
        </>
    )
}

export default {
    Provider: KualitatifContextProvider,
    Context: KualitatifContext
}